<template>
  <div>
    <header-component/>
    <fascias-component/>
    <testimonial-component/>
    <bianca-eluisa-component/>
    <speciality-component/>
<!--    <service-component/>-->
    <footer>
      <footer-component/>
    </footer>
  </div>
</template>

<script>
import HeaderComponent from '@/components/Header.vue'
import TestimonialComponent from "@/components/Testimonial.vue";
// import ServiceComponent from "@/components/Services.vue";
import FooterComponent from '@/components/Footer.vue'
import BiancaEluisaComponent from "@/components/BiancaEluisa.vue";
import SpecialityComponent from "@/components/Speciality.vue";
import FasciasComponent from "@/components/Fascias.vue";


export default {
  name: 'HomeView',
  components: {
    FasciasComponent,
    SpecialityComponent,
    BiancaEluisaComponent,
    // ServiceComponent,
    HeaderComponent,
    TestimonialComponent,
    FooterComponent
  },
}
</script>